import React, { useState } from 'react';

import { BTC_LOGO, CC_LOGO, CS_LOGO, ETH_LOGO, HIVE_LOGO } from './config/images';
import { SOCIALS_LINKS } from './config/links';
import { ExternalLink } from './components/ExternalLink';
import './Login.scss';
import { APP_VERSION } from './config/config';


const LandingIcons = () => {
  return (
    <div className="landingicons">
      <p id="game-name">CRYPTO CHESS</p>
      <p id="cryptochess-logo">
        <img src={CC_LOGO} alt="Chess" className="image chess" />
      </p>
      <p id="game-owner-label" className="small-text">by</p>
      <p id="cryptoshots-logo">
        <ExternalLink href={SOCIALS_LINKS.WEBSITE}>
          <img
            id="cs-img"
            src={CS_LOGO}
            alt="Crypto Shots"
            className="logo cs-logo"
            />
        </ExternalLink>
      </p>
    </div>
  );
};


// TODO:
// server-side verification (needed?)
const verifySignatureBackend = async (username, message, signedResult) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, 1000);
  });
};

const LoginMethods = ({ appData, handleLogin }) => {
  const { players: expectedPlayers = {}, isInviteMatch = false } = appData;
  const [username, setUsername] = useState(localStorage.getItem('username') || '');

  const authenticate = () => {
    if (!username) return;
    // If invite: check username match
    if (isInviteMatch && username !== expectedPlayers.player1 && username !== expectedPlayers.player2) {
      alert(`You (${username}) were not in this invite. Use the expected user or remove the url parameters for a new game.`);
      return;
    }
    // Request signature via Hive Keychain
    if (!window.hive_keychain) {
      alert('Please install the Hive Keychain and import your Hive Posting key in it.');
      return;
    }
    const message = `Crypto Chess login`;
    window.hive_keychain.requestSignBuffer(username, message, 'Posting', async (response) => {
      if (!response.success) {
        alert('Hive Keychain signing failed, please try again.');
        return;
      }
      const isValid = true; // TODO: server check
      if (!isValid) {
        alert('Invalid signature, please try again.');
        return;
      }
      handleLogin(username);
      localStorage.setItem('username', username);
    });
  };

  const handleGuest = () => {
    const now = Date.now();
    const random = Math.random();
    const username = `guest-${`${random * now}`.substring(0, 6)}`;
    handleLogin(username);
    localStorage.setItem('username', username);
  };

  return (
    <form
      onSubmit={(event) => {
        console.log({ event });
        event.preventDefault();
        authenticate();
      }}
    >
      <input
        id="username"
        type="text"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        placeholder="Enter username/address"
      />
      <div id="login-methods">
        <div className="login-with">
          <button type="submit">Connect</button>
          <img src={HIVE_LOGO} alt="Hive Logo" className="logo chain-logo" />
        </div>
        <div className="login-with">
          <button type="submit" disabled>Connect</button>
          <img src={BTC_LOGO} alt="Bitcoin Logo" className="logo chain-logo" />
        </div>
        <div className="login-with">
          <button type="submit" disabled>Connect</button>
          <img src={ETH_LOGO} alt="Ethereum Logo" className="logo chain-logo" />
        </div>
        <div className="login-with guest-login">
          <div className="guest-container">
            <p className="label">...or play as</p>
            <button type="button" className="guest-btn" onClick={handleGuest}>
              GUEST
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};


export const Login = ({ handleLogin, appData }) => {
  return (
    <div className="login">
      <LandingIcons/>
      <LoginMethods {...{ appData, handleLogin }}/>
      <div className="version">v{APP_VERSION}</div>
      <div className="url-params">{window.location.search ? '🟢' : ''}</div>
    </div>
  );
};
